<template>
  <fragment>
    <v-navigation-drawer v-model="navigationDrawer" app disable-resize-watcher width="300">
      <main-nav-sidebar />
    </v-navigation-drawer>
    <v-app-bar app fixed color="white">
      <fragment v-if="$vuetify.breakpoint.mdAndDown">
        <v-app-bar-nav-icon @click.stop="navigationDrawer = !navigationDrawer" />
        <v-spacer />
        <div>
          <v-img :src="require(`../assets/TMX_logo.png`)" height="38" width="80" @click="$router.push('/')" style="cursor: pointer;"/>
        </div>
        <v-spacer />
        <!--v-icon color="primary" @click="toggleSnackBar">
          mdi-information
        </v-icon-->
        <!--language-change-dropdown /-->
      </fragment>
      <fragment v-else>
        <v-container>
          <v-row justify="center">
            <main-nav-bar />
          </v-row>
        </v-container>
      </fragment>
    </v-app-bar>
    <v-content id="samsung-wrap">
      <router-view></router-view>
    </v-content>
    <tm-footer app/>
    <v-fade-transition>
      <v-btn fab class="primary" dark fixed bottom right @click="scrollToTop" v-show="showToTopButton">
        <v-icon>
          mdi-chevron-up
        </v-icon>
      </v-btn>
    </v-fade-transition>
    <!--v-snackbar v-model="showSnackbar" absolute right top :timeout="5000" color="white" style="margin-top: 60px;">
      <div v-html="$t('infoPopup')" class="text--primary pa-2" style="max-width: 320px;"></div>
    </v-snackbar-->
  </fragment>
</template>

<script>

import mainNavBar from '../components/mainNavBar.vue';
import mainNavSidebar from '../components/mainNavSidebar.vue';
import tmFooter from '../components/tmFooter.vue';
import { SCROLL_TO_TOP_BUTTON_LIMIT } from '../plugins/appConst';
import * as langHelper from '../utils/langHelper';
import languageChangeDropdown from '../components/languageChangeDropdown.vue';

export default {
  name: 'App',
  components: {
    mainNavBar, mainNavSidebar, tmFooter, languageChangeDropdown,
  },
  beforeMount() {
    this.detectLanguage();
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  data: () => ({
    navigationDrawer: false,
    showToTopButton: false,
    showSnackbar: false,
  }),
  methods: {
    scrollToTop() {
      this.$vuetify.goTo(0, { duration: 800, offset: 0 });
    },
    handleScroll() {

      this.showToTopButton = window.scrollY > SCROLL_TO_TOP_BUTTON_LIMIT;
    },
    toggleSnackBar() {
      this.showSnackbar = true;
    },
  },
};
</script>
